import { BlacklistMemberDetailsDto } from './blacklistmemberdetailsdto';

export interface AddToBlacklistDto
{
    getClientTxnId(): string;
    getLanguage(): string;
    getAPartyMsisdn(): string;
    getChannelId(): string;
    getMemberDetails(): BlacklistMemberDetailsDto[];
}

export class AddToBlacklistDtoImpl implements AddToBlacklistDto
{
    private clientTxnId: string;
    private language: string;
    private aPartyMsisdn: string;
    private channelId: string;
    private memberDetails: BlacklistMemberDetailsDto[];

    getClientTxnId(): string
    {
        return this.clientTxnId;
    }
    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }

    getLanguage(): string
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    setAPartyMsisdn(aPartyMsisdn: string)
    {
        this.aPartyMsisdn = aPartyMsisdn;
    }
    getAPartyMsisdn(): string
    {
        return this.aPartyMsisdn;
    }

    setChannelId(channelId: string)
    {
        this.channelId = channelId;
    } 
    getChannelId(): string 
    {
        return this.channelId;
    }

    setMemberDetails(memberDetails: BlacklistMemberDetailsDto[])
    {
        this.memberDetails = memberDetails;
    }
    getMemberDetails(): BlacklistMemberDetailsDto[] 
    {
        return this.memberDetails;
    }  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/addtoblacklist/addtoblacklistdto.ts